var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{attrs:{"to":{ name: 'addon-radar-grid-rg-object-history-player' }}},[_c('div',{staticClass:"menu-icon-button",class:{ 'mobile-menu-icon-button': this.isMobileDevice }},[_c('vx-tooltip',{attrs:{"text":"過去履歴表示","position":"right"}},[_c('div',{staticClass:"menu-icon cursor-pointer"})])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }